"use client";

type Props = {
  count: number;
  confidence: number;
};

export function PillCountBadge({ count, confidence }: Props) {
  const pct = Math.round(Math.min(1, Math.max(0, confidence)) * 100);
  const unit = count === 1 ? "pill" : "pills";
  const label = `AI count ${count} ${unit}, confidence ${pct} percent`;

  return (
    <div className="ed-pill-ai-badge" aria-label={label} role="status">
      <span className="ed-pill-ai-badge__count">{count}</span>
      <span className="ed-pill-ai-badge__unit">{unit}</span>
      <span className="ed-pill-ai-badge__conf">{pct}% confidence</span>
    </div>
  );
}
